export const _index_mon = (_mon) => {
  switch (_mon) {
    case "01": return "January"
    case "02": return "February"
    case "03": return "March"
    case "04": return "April"
    case "05": return "May"
    case "06": return "June"
    case "07": return "July"
    case "08": return "August"
    case "09": return "September"
    case "10": return "October"
    case "11": return "November"
    case "12": return "December"
  }
}

export const _index_dur = (_time) => {
  let __dur
  if (_time < 4)
    __dur = "Late night"
  else if (_time < 7)
    __dur = "Early morning"
  else if (_time < 10)
    __dur = "Morning"
  else if (_time < 12)
    __dur = "Before noon"
  else if (_time < 16)
    __dur = "Afternoon"
  else if (_time < 18)
    __dur = "Later afternoon"
  else if (_time < 25)
    __dur = "Evening"
  return __dur
}



// WEBPACK FOOTER //
// ./src/helper/dateTimeOrgIndex.js